import React, { useState } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import ItemTypes from './ItemTypes';
import { fCardSelect } from '../../../../../helpers/RxServices';
import style from './card.module.sass';
import { removeComponentFromJson, sortComponentsOnDrag, addRemoveOnDragComplete, } from '../../../../../stateManager/store/formCreation/action';
import { addRemoveOnDragCompleteAsset, removeComponentFromAsset, sortAssetsOnDrag } from '../../../../../stateManager/store/assets/action';
import { setSelectedItemId, updatedSelectedItems, clearSelectedItems, setMultipleSelection } from '../../../../../stateManager/store/contextMenu/action';
import { PUSH_ACTION_STACK } from '../../../../../stateManager/store/formCreation/types';
import { findIdSelector } from './reduxSelector';
// import { store } from '../../../../stateManager';
import { useSelector } from 'react-redux';
import { getComponent } from './rendererJson'

import { ReactComponent as Delete } from '../../../../../assets/svg/deleteX.svg'
import { compareDeep, assetSelector } from '../../../../../helpers/commonFunction';
import { logger } from '../../../../../constant/winston';

function scrollParentToChild(parent: Element, child: HTMLElement) {
  // Where is the parent on page
  var parentRect = parent.getBoundingClientRect();
  // What can you see?
  var parentViewableArea = {
    height: parent.clientHeight,
    width: parent.clientWidth
  };

  // Where is the child
  var childRect = child.getBoundingClientRect();
  // Is the child viewable?
  var isViewable = (childRect.top >= parentRect.top) && (childRect.bottom <= parentRect.top + parentViewableArea.height);

  // if you can't see the child try to scroll parent
  if (!isViewable) {
    // Should we scroll using top or bottom? Find the smaller ABS adjustment with some offset
    const scrollTop = childRect.top - parentRect.top - 100;
    const scrollBot = childRect.bottom - parentRect.bottom + 100;
    if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
      // we're near the top of the list
      parent.scrollTop += scrollTop;
    } else {
      // we're near the bottom of the list
      parent.scrollTop += scrollBot;
    }
  }
}

const Card: React.FC<any> = ({
  id,
  name,
  canEdit,
  JsonData,
  containerBg,
  assetRoot = false,
}) => {
  const [selectId, setSelectId] = useState<any | null>();
  const dispatch = useDispatch();
  const params: any = useParams();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // if the container is used as a root element, apply some horizontal margin
  const re = new RegExp("^tab-[0-9]#container-[0-9]$");
  const isDirectChildOfTab = re.test(id);
  const spacing = isDirectChildOfTab ? 1 : 0;

  const cardContainer = useSelector((state: any) => {
    const assets = state.assets.list;
    const assetEditMode = state.assets.assetEditMode;
    const selectedAssetId = state.assets.selectedAssetId;
    const cardIdSplit = id.split('#');
    cardIdSplit.pop()

    const val = assetEditMode ? assetSelector(assets[selectedAssetId], cardIdSplit) : findIdSelector(state, params.formId, cardIdSplit, true)
    return val
  }, compareDeep)

  const selectedItemsId = useSelector((state: any) => state.contextMenu.selectedItemsId)
  const isMultipleSelection = useSelector((state: any) => state.contextMenu.isMultipleSelection)
  const assetEditMode = useSelector((state: any) => state.assets.assetEditMode)
  const selectedAssetId = useSelector((state: any) => state.assets.selectedAssetId)
  const isChildAsset = JsonData.isChildAsset

  const cardIdSplit = id.split('#');
  const containerIdSplit = cardIdSplit.slice(0, -1)
  const containerId = containerIdSplit.join('#')
  // const JsonData = findIdSelector(store.getState(), params.formId, cardIdSplit, true)
  // const cardContainer = findIdSelector(store.getState(), params.formId, containerIdSplit, true)
  const Component = getComponent(JsonData.type)

  let originalIndex: any;
  cardContainer && cardContainer?.fields?.forEach((res: any, index: number) => {
    if (res.id === id) {
      originalIndex = index;
    }
  })
  // const getContainer = (state: any) => {
  //   cardIdSplit.pop()
  //   return findIdSelector(state, params.formId, cardIdSplit, true)
  // }

  fCardSelect.getMessage().subscribe((res) => {
    if (res.id === id) {
      setSelectId(res.id);
      const parent = document.querySelector(".override-collapse");
      const child = document.getElementById(res.json.id);
      if (parent && child) {
        scrollParentToChild(parent, child);
      }
    } else {
      if (selectId) setSelectId(null);
    }
  })

  const [{ isOverCurrent }, drop] = useDrop({
    accept: [ItemTypes.CARD, ItemTypes.CONTAINER],
    canDrop: (item: any) => {
      //Dropping into a section/container is handled inside respective components, hence restricting it here
      if (isOverCurrent) {
        if (name !== 'Section' && item.containerId === containerId) return true
        if (name !== 'Container' && item.containerId === containerId) return true
        return false
      }
      return false
    },
    collect: monitor => ({
      isOverCurrent: monitor.isOver({ shallow: true }),
    }),
    drop: (item: any) => {
      if (isOverCurrent && item.id !== id) {
        if (assetEditMode && selectedAssetId) {
          dispatch(sortAssetsOnDrag({
            assetId: selectedAssetId,
            draggedItem: item.json,
            container: item.container,
            addIndex: originalIndex
          }))
        } else {
          dispatch(sortComponentsOnDrag({
            formId: params.formId,
            draggedItem: item.json,
            container: item.container,
            addIndex: originalIndex
          }))
        }
      }
    }
  })

  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.CARD, id, originalIndex, json: JsonData, containerId: containerId, container: cardContainer },
    collect: (monitor: any) => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag: () => {
      return (name !== 'Container')
    },
    end: (draggedItem: any, monitor) => {
      //Remove dragged item from dragged container
      if (monitor.didDrop() && cardContainer) {
        const deleteData: any = {
          formid: params.formId,
          draggedItemContainer: JSON.parse(JSON.stringify(cardContainer)),
          itemId: draggedItem.id
        }

        const undoDeleteData: any = {
          formid: params.formId,
          droppedContainer: { json: JSON.parse(JSON.stringify(cardContainer)) },
          draggedItem: JSON.parse(JSON.stringify(draggedItem))
        }

        const { isDragComplete, addData, undoAddData } = monitor.getDropResult()

        if (assetEditMode && selectedAssetId) {
          isDragComplete && dispatch(addRemoveOnDragCompleteAsset(deleteData, addData))
        } else {
          isDragComplete && dispatch({
            type: PUSH_ACTION_STACK,
            data: {
              undo: () => {
                dispatch(addRemoveOnDragComplete(undoAddData, undoDeleteData, true))
              },
              redo: () => {
                dispatch(addRemoveOnDragComplete(deleteData, addData))
              }
            }
          })

          isDragComplete && dispatch(addRemoveOnDragComplete(deleteData, addData))
        }
      }
    }
  })

  const deleteCard = () => {
    dispatch({
      type: PUSH_ACTION_STACK,
      data: {
        undo: () => {
          dispatch(removeComponentFromJson(
            {
              formid: params.formId,
              draggedItemContainer: JSON.parse(JSON.stringify(cardContainer)),
              itemId: id
            }, true
          ))
        },
        redo: () => {
          dispatch(removeComponentFromJson(
            {
              formid: params.formId,
              draggedItemContainer: JSON.parse(JSON.stringify(cardContainer)),
              itemId: id
            }
          ))
        }
      }
    })

    if (assetEditMode && selectedAssetId) {
      dispatch(removeComponentFromAsset({
        assetId: selectedAssetId,
        draggedItemContainer: JSON.parse(JSON.stringify(cardContainer)),
        itemId: id,
      }))
    } else {
      dispatch(removeComponentFromJson(
        {
          formid: params.formId,
          draggedItemContainer: JSON.parse(JSON.stringify(cardContainer)),
          itemId: id
        }
      ))
    }
  }

  const makeDroupDownVisibleFalse = () => {
    setDropdownOpen(false)
  }
  const selectCard = (e: React.MouseEvent<HTMLElement>) => {
    const a: any = e.target;
    if (a.classList.contains('ant-select-selection') || a.classList.contains('ant-select-dropdown-menu-item') || a.classList.contains('ant-select-selection__placeholder') || a.classList.contains('ant-select-selection__rendered')) {
      setDropdownOpen(!dropdownOpen)
      return 0;
    }

    const selectedSection = id.split("#").slice(0, 2).join("#");
    fCardSelect.sendMessage({ id: id, json: { ...JsonData, selectedSection } });
    e.stopPropagation();

    if (e.shiftKey) {
      dispatch(setMultipleSelection(true))
      dispatch(updatedSelectedItems(id))
    } else {
      dispatch(setMultipleSelection(false))
      dispatch(setSelectedItemId(id))
      dispatch(clearSelectedItems())
    }
  }

  const opacity = isDragging ? 0.25 : 1
  selectId === id && logger.debug(JsonData)
  const layout = JsonData && JsonData.properties && JsonData.properties.layout
  // const height: any = layout ? (['px','%'].includes(layout.heightMode) ?  `${layout.height}${layout.heightMode}` : 'auto') : undefined
  // const width: any = layout ? (['px','%'].includes(layout.widthMode) ?  `${layout.width}${layout.widthMode}` : 'auto') : undefined

  const computeHeight = () => {
    if (layout.heightMode === 'px' || layout.heightMode === '%') {
      return `${layout.height}${layout.heightMode}`
    }
    if (layout.heightMode === 'fill' && layout.parent === 'row') {
      return '100%'
    }
    if (JsonData.type === 'Container' && !layout.parent) {
      return '100%'
    }
    return 'max-content'
  }

  const computeWidth = () => {
    if (layout.widthMode === 'px' || layout.widthMode === '%') {
      return `${layout.width}${layout.widthMode}`
    }
    if (layout.widthMode === 'fill' && layout.parent === 'column') {
      return '100%'
    }
    if (JsonData.type === 'Container' && !layout.parent) {
      return '100%'
    }
    return 'max-content'
  }

  const computeFlexGrow = () => {
    if (layout.parent === 'row') {
      if (layout.widthConstraint) {
        return 1
      }
      if (layout.widthMode === 'fill') {
        return 1
      }
      if (layout.widthMode === 'wrap') {
        return 0
      }
      return undefined
    }
    // else it is a column
    else {
      if (layout.heightMode === 'fill') {
        return 1
      }
      if (layout.heightMode === 'wrap') {
        return 0
      }
      return undefined
    }
  }

  const containerStyle: any = layout ? {
    outline: layout.direction ? '1px solid #dbdbdb' : undefined,
    height: computeHeight(),
    width: !((layout.widthConstraint && layout.minWidth) || (layout.widthConstraint && layout.maxWidth)) ? computeWidth() : 'auto',
    margin: `${layout.marginTop || spacing || 0}px ${layout.marginRight || 0}px ${layout.marginBottom || spacing || 0}px ${layout.marginLeft || 0}px`,
    padding: `${layout.paddingTop || 10}px ${layout.paddingRight || 10}px ${layout.paddingBottom || 10}px ${layout.paddingLeft || 10}px`,
    flexBasis: layout.widthConstraint ? `${layout.minWidth}px` : undefined,
    maxWidth: layout.widthConstraint ? `${layout.maxWidth}px` : undefined,
    flexGrow: computeFlexGrow(),
    // overflow: 'auto',
    alignSelf: (layout.parent === 'row' ? layout.vertical : layout.horizontal),
  }
    :
    {}

  const computedClassName: any = !layout ? (JsonData.size + ' ' + style.size) : undefined
  const computedStyle: any = {
    cursor: 'grab',
    opacity,
    position: 'relative',
    marginBottom: '0px',
    padding: (JsonData.type === 'Container' && layout && layout.parent) ? '0px' : '10px',
    backgroundColor: (selectId !== id) ? 'transparent' : containerBg ? containerBg : '#fafafa',
    border: (selectId === id || selectedItemsId.includes(id)) ? '1px dashed black' : undefined,
    ...containerStyle,
  }

  return (
    <React.Fragment>
      <div data-test-id="select_card" id={JsonData.elementId} ref={(ref) => canEdit ? drag(drop(ref)) : null} onClick={selectCard} onBlur={makeDroupDownVisibleFalse} className={computedClassName} style={computedStyle}>
        {
          (selectId === id && !isDragging && !assetRoot && canEdit && !isMultipleSelection && (!isChildAsset || assetEditMode))
            ?
            <div data-test-id="selected_card_delete" className={style.selectedCardDelete} onClick={deleteCard}>
              <Delete />
            </div>
            :
            null
        }
        <Component
          data-test-id="card_component"
          id={id}
          json={JsonData}
          canEdit={canEdit}
          open={dropdownOpen}
        />
      </div>
    </React.Fragment>
  )

}

export default React.memo(Card, compareDeep);

